export default __webpack_public_path__ + "static/media/verifyIDIcon.7e053285.svg";